import { SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";
import { Ability } from "../../core/ablvl";

import * as type from "../../core/type";
import * as state from "../../core/state";
import * as effect from "../../core/effect";
import * as cond from "../../core/cond";

export const 盛世华光 = new SpecialAttackSkill(
    "盛世华光",
    type.飞行·神秘,
    [
        "无视对手免疫伤害效果",
        "2回合内，对手无法使用属性技能",
        "消除对手的能力提升，消除成功则下2回合必定先出手",
    ],
    80,
    [
        new Effect(new effect.消除强化(), Timing.onDamage),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.属性封印(),
            Timing.beforeSkillHit,
            undefined,
            true,
        ),
    ],
    3,
);

export const 青鸟千羽 = new SpecialAttackSkill(
    "青鸟千羽",
    type.飞行·神秘,
    [
        "若自身处于能力下降状态则先制+3",
        "反转自身的能力下降，反转成功则恢复自身最大体力的1/1",
        "2回合内，若击败对手则免疫下1次受到的攻击",
    ],
    120,
    [],
    0,
    true,
);

export const 空桑林语 = new StatusSkill(
    "空桑林语",
    [
        "全属性+1，体力低于1/2时强化效果翻倍",
        "4回合内，免疫并反弹异常状态",
        "4回合内，受到的固定伤害和百分比伤害减少50%",
        "下2回合所有技能先制+2",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若自身体力低于x分之一(2)),
            Timing.onSkillHit,
        ),
    ],
);

export const 启明星辰击 = new SpecialAttackSkill(
    "启明星辰击",
    type.飞行·神秘,
    [
        "2回合内，每回合有70%的几率令对手睡眠，未触发则免疫下1次异常状态",
        "当回合未击败对手，则下2回合直接攻击必定致命一击",
    ],
    150,
    [
        new RoundEffect(
            Timing.onDamage,
            2,
            new effect.施加异常状态(new state.睡眠()),
            Timing.actionEnd,
            cond.百分之x的几率(70),
            false,
            [],
        ),
        new RoundEffect(
            Timing.onDamage,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
    1,
    false,
);

export const 凌霄舞乾坤 = new SpecialAttackSkill(
    "凌霄舞乾坤",
    type.飞行·神秘,
    [
        "消除对手的回合类效果，消除成功则免疫下1回合受到的攻击",
        "吸取对手200点体力，每次使用增加100点，最高500点",
        "当回合未击败对手，则令对手攻击、特攻等级-2，特防等级-1，且随机1个技能pp值归零",
    ],
    160,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new RoundEffect(
                Timing.triggered,
                1,
                new effect.免疫攻击(),
                Timing.beforeSkillHit,
            ).nextRound(),
        ]),
        new Effect(new effect.吸取体力(200, 100, 500), Timing.onDamage),
        new RoundEffect(
            Timing.onSkillHit,
            1,
            new effect.属性下降({ pAtk: 2, mAtk: 2, mDef: 1 }),
            Timing.battleStageEnd,
            ({ objPet }) => objPet.isAlive(),
        ).thisRound(),
    ],
    0,
    true,
);
